<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-skip-previous`]" width="1em" height="1em" v-bind="$attrs"><path d="M34.414 35.855a1 1 0 001.586-.81v-22.09a1 1 0 00-1.586-.81L19.122 23.19a1 1 0 000 1.622l15.292 11.044z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15 12a1 1 0 011 1v22a1 1 0 01-1 1h-2a1 1 0 01-1-1V13a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSkipPrevious',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
